module.exports = __webpack_public_path__ + "static/media/colored-wood.9a2520e0.jpg";